import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const FocalMapContext = createContext({ map: {}, refresh: () => {} });

export function FocalMapProvider({ children }) {
    const [map, setMap] = useState({});

    const refresh = () => {
        api.get("/image-focal-map")
            .then((r) => setMap(r.data || {}))
            .catch(() => {});
    };

    useEffect(() => {
        refresh();
    }, []);

    return (
        <FocalMapContext.Provider value={{ map, refresh }}>
            {children}
        </FocalMapContext.Provider>
    );
}

export function useFocalMap() {
    return useContext(FocalMapContext);
}

// Returns undefined (no override) when no focal point is set, so the element's
// existing `object-*` Tailwind class (e.g. object-top) keeps working by default.
export function getObjectPosition(map, src) {
    const point = src && map[src];
    if (!point) return undefined;
    const [x, y] = point;
    return `${x}% ${y}%`;
}
